import classNames from 'classnames';
import _ from 'lodash';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useProUpsellModal } from '../../../../hooks/use_pro_upsell_modal';
import { useUser } from '../../../../hooks/use_user';
import { SignupLoginModalActions } from '../../../../redux/signup_login_modal';
import { PRO_SIGNUP_LOGIN_MODAL_OPEN_PARAMS } from '../../../login_signup_modal/signup_login_modal';
import SvgLockIcon from '../../../svg/lock_icon';
import {
  CORE_LAYER,
  CORE_LAYER_INFO,
  LAYER_TYPES,
  MapLayerState,
  OVERLAY_LAYER,
  WEATHER_LAYER,
} from '../../map_types';
import { ModalNonProFooter } from '../modal_non_pro_footer/modal_non_pro_footer';
import styles from './water_layers_modal.less';

const isLayerComingSoon = (value: string) => {
  return false;
  // return value === CORE_LAYER.WATER_TEMP_REAL_TIME;
};
const isLayerAppOnly = (value: string) => {
  return value === CORE_LAYER.NAVIONICS;
};

interface WaterLayersModalProps {
  mapLayerState: MapLayerState;
  onCoreLayerChange: (layer: CORE_LAYER) => void;
  isOpen: boolean;
}

export const WaterLayersModal = (props: WaterLayersModalProps) => {
  const { mapLayerState, isOpen, onCoreLayerChange } = props;
  const { isPro, user } = useUser();
  const isNotPro = !isPro;
  const dispatch = useDispatch();
  const { openProUpsellModal } = useProUpsellModal();

  const orderedCoreLayers = _.orderBy(Object.values(CORE_LAYER_INFO), ['order'], ['asc']);

  const handleLayerChange = (
    value: CORE_LAYER | WEATHER_LAYER | OVERLAY_LAYER,
    type: 'core' | 'weather'
  ) => {
    if (!user) {
      dispatch(SignupLoginModalActions.SIGNUP_LOGIN_MODAL_OPEN(PRO_SIGNUP_LOGIN_MODAL_OPEN_PARAMS));
    } else if (isNotPro) {
      openProUpsellModal();
    } else if (isPro) {
      if (type === 'core') {
        if (isLayerComingSoon(value) || isLayerAppOnly(value)) {
          return;
        }
        onCoreLayerChange(value as CORE_LAYER);
        return;
      }
    }
  };
  if (!isOpen) {
    return null;
  }

  return (
    <div className={styles.modal}>
      {orderedCoreLayers.map(({ icon, name, value }) => {
        const Icon = icon;
        const shortenedName = name.replace('Social', '');
        const isCoreLayerSelected = mapLayerState[LAYER_TYPES.CORE] === value;
        const isAppOnly = isLayerAppOnly(value);
        return (
          <div
            key={shortenedName}
            className={classNames(styles.layerItem, {
              [styles.layerItem__selected]: isCoreLayerSelected,
              [styles.layerItem__comingSoon]: isLayerComingSoon(value),
              [styles.layerItem__appOnly]: isAppOnly,
            })}
            onClick={() => handleLayerChange(value as CORE_LAYER, 'core')}
          >
            {isNotPro || isAppOnly ? (
              <span className={classNames(styles.lockIcon, 'text-orange')}>
                <SvgLockIcon />
              </span>
            ) : (
              <span
                className={classNames(styles.radio, {
                  [styles.radio__selected]: isCoreLayerSelected,
                })}
              />
            )}
            <span className={styles.label}>{shortenedName}</span>
            <input
              type="radio"
              id={shortenedName}
              checked={isCoreLayerSelected}
              name="coreLayer"
              value={value}
              onChange={() => handleLayerChange(value as CORE_LAYER, 'core')}
              hidden
            />
            <span
              className={classNames(styles.layerIcon, {
                [styles.layerIcon__appOnly]: isAppOnly,
              })}
            >
              {isLayerComingSoon(value) ? (
                <>
                  <span className={styles.comingSoon}>Coming Soon</span>
                </>
              ) : isAppOnly ? (
                <>
                  <span className={styles.appOnly}>App Only</span>
                </>
              ) : (
                <Icon />
              )}
            </span>
          </div>
        );
      })}
      {isNotPro && <ModalNonProFooter />}
    </div>
  );
};
